(ns minorodata.statuses.events
  "Last-run execution status for every kind of runnable entity, in one place.

   Statuses arrive from endpoints covering different SLICES of the same data — every
   extract, only the failing ones — so every write is an UPSERT keyed by entity id,
   which is what lets a narrow fetch and a wide one share a store. Where both slices
   carry the same entity, keying alone would only make the winner depend on response
   order, so rows are resolved by run date (`newer-run`) rather than merged flat.
   Entries are raw wire maps under `[:statuses <kind> <id>]`, never transacted into
   DataScript.

   Transform statuses have not moved here yet: `transform-status-list` has ~18
   consumers including the legacy bleene graph shared with Jumper."
  (:require
   [minorodata.statuses.domain :refer [index-by-id kind->id-key newer-run]]
   [re-frame.core :as re-frame]))


;; Nothing is dropped for being absent from the response, so an entity deleted
;; mid-session keeps its last status until the next page load.
(re-frame/reg-event-db
 :statuses.events/upsert
 (fn [db [_ kind rows]]
   (if-let [id-key (kind->id-key kind)]
     (update-in db [:statuses kind] #(merge-with newer-run % (index-by-id id-key rows)))
     (do (js/console.error "[statuses/upsert] unknown entity kind:" (str kind))
         db))))
